import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {withRouter} from 'react-router';
import _ from 'lodash';
import PolicyDropdown from "./PolicyDropdown";
import {tooltip} from "components/Tooltips/HeaderTooltips";
import {WhisperWrapper} from "components/Tooltips/WhisperWrapper";

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFacility: null,
            logoutDropdownVisible: false,
            policyDropdownVisible: false
        };
        this.handleLogout = this.handleLogout.bind(this);
        this.policyDropdownToggle = this.policyDropdownToggle.bind(this);
        this.policyDropdownClose = this.policyDropdownClose.bind(this);
    }

    handleLogout() {
        this.setState({logoutDropdownVisible: false});
        this.props.auth.logout();
    }

    parseRoute(routePath) {
        // Get path details from the URL
        const routeParts = _.tail(routePath);
        // console.table(routeParts);
        const startsWithOrg = routeParts[0] === 'organizations';
        const startsWithFacility = routeParts[0] === 'facilities';
        const sectionAction = _.last(routeParts);
        const selectedFacility = startsWithFacility ? routeParts[1] : '';
        const selectedSection = startsWithFacility ? routeParts[3] : '';
        return {
            ...routeParts,
            sectionAction,
            selectedFacility,
            selectedSection,
            startsWithOrg,
            startsWithFacility
        };
    }

    render() {
        const {auth} = this.props;
        const {logoutDropdownVisible, policyDropdownVisible} = this.state;
        const {currentUser} = auth;
        const userDisplayName = _.get(currentUser, 'profile.nickname', _.get(currentUser, 'profile.email'));
        const userRoles = _.get(currentUser, 'role', []);
        const onConfigurationPages = this.props.location.pathname.indexOf('configuration') > -1;
        const canConfigure = userRoles.includes('admin') && !auth.isDemoUser();
        const routeParsed = this.parseRoute(this.props.location.pathname.split('/'));
        // console.log({routeParsed});
        // const {1: orgId, 2: facilityId, 3: sectionId, 4: sectionAction} = _.tail(this.props.location.pathname.split('/'));

        // return (<MainMenu />);
        return (
            <nav className='navbar navbar-expand-md navbar-light bg-light fixed-top'>
                <div className='container'>
                    <span className='navbar-brand logo'>Keenly Health</span>

                    {currentUser &&
                        <ul className='navbar-nav'>
                            <li className={routeParsed.sectionAction === 'rooms' || routeParsed.sectionAction === 'neighborhood-data' || routeParsed.startsWithOrg ? 'nav-item active' : 'nav-item'}>
                                <Link to={`/organizations/${auth.organizationDetails}/show`}
                                      className='nav-link'>Locations</Link>
                            </li>

                            {canConfigure && (
                                <WhisperWrapper
                                    tooltip={tooltip}
                                    props={{placement: "bottom", controlId: "control-id-hover", trigger: "hover"}}
                                >
                                    <li className={onConfigurationPages ? 'nav-item active' : 'nav-item'}>
                                        <Link to={`/configuration/devices`} className='nav-link'>Configuration</Link>
                                    </li>
                                </WhisperWrapper>
                            )}
                        </ul>
                    }

                    <div className='policy-link'>
                        <a className='icon-question' href='' onClick={this.policyDropdownToggle}></a>
                    </div>
                    {policyDropdownVisible && <PolicyDropdown handleClose={this.policyDropdownClose}/>}
                    {currentUser &&
                        <div className={logoutDropdownVisible ? 'user-actions dropdown show' : 'user-actions dropdown'}>
                            <div
                                className='d-flex align-items-center'
                                onClick={() => this.setState((prevState) => ({logoutDropdownVisible: !prevState.logoutDropdownVisible}))}>
                                <div className='d-flex flex-column align-items-end'>
                                    <span className='userName'>Welcome, {userDisplayName}</span>
                                </div>
                                <i className='carat fas fa-angle-down fa-lg'/>
                            </div>

                            <div className={logoutDropdownVisible ? 'dropdown-menu show' : 'dropdown-menu'}>
                                <button className='dropdown-item' onClick={this.handleLogout}>
                                    Log Out
                                </button>
                            </div>
                        </div>
                    }
                </div>
            </nav>
        );
    }

    policyDropdownToggle(e) {
        e.preventDefault();
        this.setState((prevState) => ({policyDropdownVisible: !prevState.policyDropdownVisible}));
    }

    policyDropdownClose() {
        this.setState({policyDropdownVisible: false});
    }
}

export default withRouter(Header);
